import { IUser } from '@pia/pia.shared';
import { InjectionToken } from '@angular/core';

export const AuthenticationToken = new InjectionToken('AuthenticationToken');

export interface IAuthenticationAccount {
  account: IUser;
  ready: Promise<void>;
}
